<template>
  <div id="app">
    <img alt="Devfinder logo" src="./assets/devfinder-logo.svg" />
    <Dashboard msg="Welcome to Your Vue.js App" />
  </div>
</template>

<script>
import Dashboard from "./components/Dashboard.vue";

export default {
  name: "App",
  components: {
    Dashboard,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  padding: 30px;
  background-color: #333 !important;
  background-attachment: fixed;
  background-position: 100% 0%;
  background-repeat: no-repeat;
  background-image: url(./assets/background.svg);
}
</style>
